import { render, staticRenderFns } from "./OAuthCredentials.vue?vue&type=template&id=36bb0814"
import script from "./OAuthCredentials.vue?vue&type=script&lang=js"
export * from "./OAuthCredentials.vue?vue&type=script&lang=js"
import style0 from "./OAuthCredentials.vue?vue&type=style&index=0&id=36bb0814&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports